"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _axios = _interopRequireDefault(require("axios"));

var _lodash = _interopRequireDefault(require("lodash"));

var _cryptoJs = _interopRequireDefault(require("crypto-js"));

var _uuid = require("uuid");

var _logger = _interopRequireDefault(require("./logger"));

var _encrypt = _interopRequireDefault(require("./encrypt"));

var _pb = _interopRequireDefault(require("./pb"));

var _store = require("./store");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isNodeEnv = typeof window === 'undefined';
var reqKey = 'showReq';
var resKey = 'showRes';
var comKey = 'showCommon';

function isArrayBuffer(data) {
  if (isNodeEnv) {
    return _lodash["default"].isBuffer(data) || _lodash["default"].isArrayBuffer(data);
  }

  return _lodash["default"].isArrayBuffer(data);
}

var Request = /*#__PURE__*/function () {
  function Request(opt) {
    (0, _classCallCheck2["default"])(this, Request);
    var baseApiUrl = opt.baseApiUrl,
        apiPath = opt.apiPath,
        _opt$timeout = opt.timeout,
        timeout = _opt$timeout === void 0 ? 45000 : _opt$timeout,
        protobuf = opt.protobuf,
        proto = opt.proto,
        packagePrefix = opt.packagePrefix,
        fnGetEncryptParams = opt.fnGetEncryptParams,
        fnGetEncryptKey = opt.fnGetEncryptKey,
        _opt$encryptIV = opt.encryptIV,
        encryptIV = _opt$encryptIV === void 0 ? 'A-16-Byte-String' : _opt$encryptIV,
        _opt$headerParams = opt.headerParams,
        headerParams = _opt$headerParams === void 0 ? {} : _opt$headerParams;
    this.token = '';
    this.sequence = 0;
    this.accountID = '';
    this.lang = 1; // 1 en 4 ch

    this.headerParams = headerParams;
    this.retry = {};
    this.baseApiUrl = baseApiUrl;
    this.apiPath = apiPath;
    this.httpService = _axios["default"].create({
      timeout: timeout
    });
    this.protobuf = protobuf;
    this.proto = new _pb["default"]({
      proto: proto,
      packagePrefix: packagePrefix
    });
    this.encrypt = new _encrypt["default"]({
      fnGetEncryptParams: fnGetEncryptParams,
      fnGetEncryptKey: fnGetEncryptKey,
      encryptIV: encryptIV
    });
  }

  (0, _createClass2["default"])(Request, [{
    key: "create",
    value: function create(messageName, obj) {
      obj = Request.trimParams(obj);
      Request.logRequest('business name', messageName);
      Request.logRequest('business params', obj);
      var pbConstruct = this.proto.getMessage(messageName);
      var encodeParams = pbConstruct.encode(obj).finish();
      return encodeParams;
    }
  }, {
    key: "initEncrypt",
    value: function () {
      var _initEncrypt = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.encrypt.refreshEncryptKey();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initEncrypt() {
        return _initEncrypt.apply(this, arguments);
      }

      return initEncrypt;
    }()
  }, {
    key: "send",
    value: function () {
      var _send = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(params) {
        var _params$type, type, response;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _params$type = params.type, type = _params$type === void 0 ? 'pb' : _params$type;

                if (!params._requestID) {
                  params._requestID = (0, _uuid.v4)();
                }

                this.retry[params._requestID] = this.retry[params._requestID] || 0;
                _context2.prev = 3;

                if (!(type === 'pb')) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 7;
                return this.requestPB(params);

              case 7:
                response = _context2.sent;
                _context2.next = 13;
                break;

              case 10:
                _context2.next = 12;
                return this.requestOther(params);

              case 12:
                response = _context2.sent;

              case 13:
                return _context2.abrupt("return", this.handleResponseData(response, params));

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](3);
                throw _context2.t0;

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 16]]);
      }));

      function send(_x) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "transformRequestFactory",
    value: function transformRequestFactory(needEncrypt) {
      var _this = this;

      return function (data) {
        var PBMessageRequest = _this.proto.getMessage('Request');

        var ret = PBMessageRequest.encode(data).finish();

        if (needEncrypt) {
          ret = _this.encrypt.encrypt(ret);
        }

        return ret;
      };
    }
  }, {
    key: "transformResponseFactory",
    value: function transformResponseFactory(responseType) {
      var _this2 = this;

      return function (rawResponse) {
        var de = rawResponse;
        Request.logCommon('response rawData', de);

        if (typeof de === 'string') {
          de = _this2.encrypt.decrypt(de);
        } // 判断response是否是arrayBuffer


        Request.logCommon('response data is ArrayBuffer', isArrayBuffer(de));
        Request.logCommon('response descrypted rawData', de);

        if (de == null || !isArrayBuffer(de)) {
          return de;
        }

        try {
          var buf = _this2.protobuf.util.newBuffer(de); // decode响应体


          var PBMessageResponse = _this2.proto.getMessage("Response");

          var decodedResponse = PBMessageResponse.decode(buf);

          if (decodedResponse.header && decodedResponse.header.dataType) {
            // dataType
            var packagePrefix = _this2.packagePrefix || "hk.com.easyview.protobuf.bean";
            var dataType = decodedResponse.header.dataType.replace(packagePrefix + ".", "");

            var model = _this2.proto.getMessage(dataType);

            decodedResponse.data = model.decode(decodedResponse.data);
          } else if (decodedResponse.data && responseType) {
            var _model = _this2.proto.getMessage(responseType);

            decodedResponse.data = _model.decode(decodedResponse.data);
          }

          return decodedResponse;
        } catch (err) {
          Request.logResponseError("decode response buffer error", err);
          return err;
        }
      };
    } // 添加自定义http request header

  }, {
    key: "getCustomReqHeader",
    value: function getCustomReqHeader(_ref) {
      var _ref$url = _ref.url,
          url = _ref$url === void 0 ? '' : _ref$url;
      var _this$headerParams = this.headerParams,
          deviceType = _this$headerParams.deviceType,
          webEntryType = _this$headerParams.webEntryType;
      var rawStr = "".concat(deviceType, "_").concat(webEntryType, "_").concat(url);

      var wordArr = _cryptoJs["default"].enc.Utf8.parse(rawStr);

      var parsedStr = _cryptoJs["default"].enc.Base64.stringify(wordArr);

      return {
        ReqInfo: parsedStr
      };
    } // 发送pb请求

  }, {
    key: "requestPB",
    value: function () {
      var _requestPB = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(params) {
        var responseType, _params$encrypt, encrypt, apiPath, baseApiUrl, customHeaders, req, headers, reqOpts, reqUrl;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                responseType = params.responseType, _params$encrypt = params.encrypt, encrypt = _params$encrypt === void 0 ? true : _params$encrypt, apiPath = params.apiPath, baseApiUrl = params.baseApiUrl;
                customHeaders = this.getCustomReqHeader(params);
                req = this.getReqObj(params);
                headers = _objectSpread({
                  'Content-Type': 'application/x-protobuf'
                }, customHeaders);
                reqOpts = {
                  headers: headers,
                  responseType: 'arraybuffer',
                  transformRequest: this.transformRequestFactory(encrypt),
                  transformResponse: this.transformResponseFactory(responseType)
                }; // 是否开启对称加密

                if (encrypt) {
                  if (this.encrypt.needEncrypt) {
                    headers.EncryptToken = this.encrypt.getEncryptToken();
                    delete headers['Content-Type'];
                    delete reqOpts.responseType;
                  }
                }

                reqUrl = (baseApiUrl !== null && baseApiUrl !== void 0 ? baseApiUrl : this.baseApiUrl) + (apiPath !== null && apiPath !== void 0 ? apiPath : this.apiPath); // transformRequest 发起请求时，调用transformRequest方法，将req转换成二进制
                // transformResponse 对返回的数据进行处理，将二进制转换成真正的json数据

                return _context3.abrupt("return", this.httpService.post(reqUrl, req, reqOpts));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function requestPB(_x2) {
        return _requestPB.apply(this, arguments);
      }

      return requestPB;
    }()
  }, {
    key: "getReqObj",
    value: function getReqObj(_ref2) {
      var url = _ref2.url,
          requestBody = _ref2.requestBody,
          timestamp = _ref2.timestamp;

      // 构造请求体公共参数
      var headerParams = _objectSpread(_objectSpread({
        sequence: ++this.sequence,
        accountId: +this.accountID
      }, this.getSignature(timestamp)), {}, {
        lang: this.lang,
        url: url
      }, this.headerParams);

      Request.logRequest('business common params', headerParams); // 创建公共头参数

      var PBMessageRequestHeader = this.proto.getMessage('RequestHeader');
      var reqHeader = PBMessageRequestHeader.create(headerParams); // 构造公共请求体:PBMessageRequest

      var reqData = {
        header: reqHeader,
        data: requestBody // 加密后的请求参数

      }; // 将对象序列化成请求体实例

      var PBMessageRequest = this.proto.getMessage('Request');
      var req = PBMessageRequest.create(reqData);
      return req;
    }
  }, {
    key: "getSignature",
    value: function getSignature(time) {
      var timestamp = time !== null && time !== void 0 ? time : Date.now();

      var nonce = _cryptoJs["default"].lib.WordArray.random(16).toString();

      if (!this.accountID || !this.token) {
        return {
          timestamp: timestamp,
          nonce: nonce
        };
      }

      var signature = _cryptoJs["default"].MD5("".concat(this.accountID).concat(nonce).concat(timestamp).concat(this.token)).toString();

      return {
        signature: signature,
        timestamp: timestamp,
        nonce: nonce
      };
    }
  }, {
    key: "handleResponseData",
    value: function () {
      var _handleResponseData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(response, params) {
        var _requestID, _params$type2, type, _response$data, header, data, statusCode, resultCode;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _requestID = params._requestID, _params$type2 = params.type, type = _params$type2 === void 0 ? 'pb' : _params$type2;

                if (!isArrayBuffer(response.data)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return", {
                  data: response.data
                });

              case 3:
                Request.logCommon('response data', response.data);
                Request.logCommon('response header', response.headers);
                _response$data = response.data, header = _response$data.header, data = _response$data.data;

                if (response.headers && response.headers['gateway-code']) {
                  statusCode = +response.headers['gateway-code'];
                } else {
                  statusCode = header.code;
                }

                if (type === 'pb') {
                  Request.logResponse('response header', header);
                  Request.logResponse('response data', data);
                }

                resultCode = this.proto.getMessage('ResultCode');

                if (!((statusCode === resultCode.GATEWAY_ERROR_ENCRYPT_TOKEN || statusCode === resultCode.GATEWAY_ERROR_ENCRYPT_KEY || statusCode === resultCode.GATEWAY_ERROR_ENCRYPT_CLOSE || statusCode === resultCode.GATEWAY_ERROR_DECRYPT_FAILED) && this.retry[_requestID] < 2)) {
                  _context4.next = 16;
                  break;
                }

                this.retry[_requestID]++; // if (statusCode === resultCode.GATEWAY_ERROR_ENCRYPT_TOKEN) {
                //   this.encrypt.getEncryptToken(true);
                // }

                _context4.next = 13;
                return this.encrypt.refreshEncryptKey(params);

              case 13:
                return _context4.abrupt("return", this.send(params));

              case 16:
                delete this.retry[_requestID];

                if (!(statusCode !== resultCode.SUCCESS)) {
                  _context4.next = 21;
                  break;
                }

                throw {
                  response: response,
                  statusCode: statusCode
                };

              case 21:
                return _context4.abrupt("return", {
                  data: data,
                  originData: response.data
                });

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleResponseData(_x3, _x4) {
        return _handleResponseData.apply(this, arguments);
      }

      return handleResponseData;
    }()
  }, {
    key: "requestOther",
    value: function requestOther(params) {
      var url = params.url,
          _params$options = params.options,
          options = _params$options === void 0 ? {} : _params$options;
      var data = params.data;
      var langToBackend = this.lang;

      if (data instanceof FormData) {
        data.append('language', langToBackend);
      } else {
        data = _objectSpread(_objectSpread({}, data), {}, {
          language: langToBackend
        });
      }

      var reqUrl = this.baseApiUrl + url;
      var customHeaders = this.getCustomReqHeader({
        url: url
      });
      options.headers = options.headers || {};

      var headers = _objectSpread(_objectSpread({}, customHeaders), options.headers);

      return this.httpService.post(reqUrl, data, _objectSpread(_objectSpread({}, options), {}, {
        headers: headers
      }));
    }
  }, {
    key: "setToken",
    value: function setToken() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.token = value;
    }
  }, {
    key: "setAccountID",
    value: function setAccountID() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.accountID = value;
    }
  }, {
    key: "setLang",
    value: function setLang() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
      this.lang = value;
    } // getLangType(lang) {
    //   lang = this.lang ?? 'en';
    //   const langType = this.proto.getMessage('Language');
    //   return (
    //     {
    //       en: langType.ENGLISH,
    //       zh: langType.SIMPLE_CHINESE,
    //     }[lang] || 0
    //   );
    // }

  }], [{
    key: "logRequest",
    value: function logRequest(title, data) {
      var showLog = (0, _store.getLocalData)(reqKey);
      if (!showLog) return;
      (0, _logger["default"])("%c ==> ".concat(title, ": ").concat(JSON.stringify(data)), 'color:#00f;');
    }
  }, {
    key: "logResponse",
    value: function logResponse(title, data) {
      var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#396';
      var showLog = (0, _store.getLocalData)(resKey);
      if (!showLog) return;
      (0, _logger["default"])("%c <== ".concat(title, ": ").concat(JSON.stringify(data)), "color:".concat(color, ";"));
    }
  }, {
    key: "logCommon",
    value: function logCommon(title, data) {
      var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#000';
      var showLog = (0, _store.getLocalData)(comKey);
      if (!showLog) return;
      (0, _logger["default"])("%c common log: ".concat(title, ": ").concat(JSON.stringify(data)), "color:".concat(color, ";"));
    }
  }, {
    key: "logResponseError",
    value: function logResponseError(title, data) {
      Request.logResponse(title, data, '#f00');
    }
  }, {
    key: "trimParams",
    value: function trimParams(obj) {
      var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (depth > 10) return obj;

      for (var key in obj) {
        if ((0, _typeof2["default"])(obj[key]) === 'object') {
          obj[key] = Request.trimParams(obj[key], ++depth);
        } else if (typeof obj[key] === 'string') {
          obj[key] = obj[key].trim();
        }
      }

      return obj;
    }
  }]);
  return Request;
}();

var _default = Request;
exports["default"] = _default;